import React from "react";
import { useTranslation } from 'react-i18next';

import "./GameDate.scss";
import useFormatDays from "../../../hooks/useFormatDays";
import useFormatTime from "../../../hooks/useFormatTime";

interface GameDateProps {
  date: string;
  time: string;
  location: string;
}

function GameDate({ date, time, location }: GameDateProps) {
  const { t } = useTranslation();

  const formattedDate = useFormatDays(date ? parseInt(date) : 0);
  const formattedTime = useFormatTime(time ? parseInt(time) : 0);

  const dateValue = date ? formattedDate : "";
  const timeValue = time ? formattedTime : "";
  const locationValue = location || "";

  return (
    <div className="game-date-container">
      <div className="game-date">
        <span className="game-date_day">{dateValue}</span>
        {dateValue && <span>,</span>}
        {timeValue &&
        <span className="game-date_time">{timeValue} {t('live-panel.clock')}</span>
        }
      </div>
      <span className="game-date_location">{locationValue}</span>
    </div>
  );
}

export default GameDate;